import { useContext } from 'react';
import { useInvestor } from '@dealstack/frontend/investor/pages/Investment/hooks/useInvestor';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { BankAccountWithCodeValidation } from '@dealstack/frontend/shared/components/BankAccountWithCodeValidation/BankAccountWithCodeValidation.tsx';
import { useInvestmentBankAccountStep } from '@dealstack/frontend/investor/pages/Investment/hooks/useInvestmentBankAccountStep';
import { inferBankCountryCode } from '@dealstack/frontend/shared/components/BankAccountForm/BankAccountForm.utils.ts';
import { getMainAddress } from '@dealstack/frontend/shared/address.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Flex } from '@mantine/core';

export const InvestmentLeaveBankAccount = () => {
	// The leave flow provides the same context as the joiner.
	const { setIsContinueDisabled, setIsLoading } = useContext(investmentJoinAndAllocationContext);
	const getInvestorDataRequest = useInvestor();
	const investorData = getInvestorDataRequest.data;
	const pivPersonId = investorData?.pivPerson?.id;
	const accountOwner = pivPersonId ? investorData?.pivPerson : investorData?.person;
	const inferredCountryCode = inferBankCountryCode(
		getMainAddress(accountOwner?.addresses)?.country
	);

	const {
		dealId,
		investmentWorkflowId,
		bankAccountsData,
		bankAccountsLoading,
		refetchBankAccounts,
	} = useInvestmentBankAccountStep({
		pivPersonId,
		setIsContinueDisabled,
		setIsLoading,
	});

	return (
		<Flex direction="column" maw="40rem">
			<BankAccountWithCodeValidation
				disableNoAccountAlert={true}
				investmentWorkflowId={investmentWorkflowId}
				dealId={dealId}
				personId={pivPersonId}
				bankAccountsData={bankAccountsData}
				bankAccountsLoading={bankAccountsLoading}
				refetchBankAccounts={refetchBankAccounts}
				onMutationFinish={getInvestorDataRequest.refetch}
				dataTestId={TEST_ELEMENT_IDS.BANK_ACCOUNT_FORM}
				inferredCountryCode={inferredCountryCode}
			/>
		</Flex>
	);
};
